import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import {
  selectAllCampaignFields,
  selectCampaigns,
  selectWorkflows,
} from '../../../../../../reducers/hubspotReducer';
import { CampaignWithEnrollmentRules } from '../campaignTypes';
import { WorkflowActionType } from '../../types';

export const useCampaignFieldsAndEnrollmentRules = ():
  | CampaignWithEnrollmentRules[]
  | undefined => {
  const campaigns = useSelector(selectCampaigns);
  const campaignFields = useSelector(selectAllCampaignFields);
  const workflows = useSelector(selectWorkflows);

  return useMemo(() => {
    return campaignFields?.map((campaignFields) => {
      const campaignId = String(campaignFields.find((field) => field.name === 'Id')?.value || '');
      const enrollmentRules =
        workflows?.filter((workflow) =>
          workflow.workflowDetails.actions.some(
            (action) =>
              action.actionType === WorkflowActionType.ENROLL_CAMPAIGN &&
              action.campaignId === campaignId,
          ),
        ) || [];
      return {
        campaignFields,
        enrollmentRules,
        lastModifiedDate: campaigns?.find(
          (campaign) =>
            campaign.Id === (campaignFields.find((field) => field.name === 'Id')?.value as string),
        )?.LastModifiedDate,
        createdDate: campaigns?.find(
          (campaign) =>
            campaign.Id === (campaignFields.find((field) => field.name === 'Id')?.value as string),
        )?.CreatedDate,
      };
    });
  }, [campaignFields, campaigns, workflows]);
};
